import styled from "@emotion/styled";
import { motion } from "framer-motion";

const HoverWrapper = styled(motion.div)(() => ({
  position: "absolute",
  willChange: "transform",
  zIndex: 1,
  top: 0,
  left: 0,
  bottom: 0,
  display: "flex",
  flexDirection: "column",
  width: "100%",
  padding: "1rem",
}));

export default HoverWrapper;
